export default __webpack_public_path__ + "static/media/everyoneopen.64b25d57.mp3";